import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IdeomFormModule } from './form/ideom-form.module';
import { IdeomPopupModule } from './popup/ideom-popup.module';
import { IdeomMonitorModule } from './monitor/ideom-monitor.module';
import { IdeomUiCommonModule } from './common/ideom-ui-common.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, FormsModule, IdeomFormModule, IdeomPopupModule, IdeomMonitorModule],
  exports: [IdeomFormModule, IdeomMonitorModule, IdeomPopupModule, IdeomUiCommonModule],
})
export class IdeomUiModule {}
